import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { Router } from '@angular/router';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { PrestadorModel } from 'src/app/shared/models/prestador.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { DetalleSolicitudService } from '../../containers/bandeja-principal/funcionario/detalle-solicitud/detalle-solicitud.service';
import { NotificacionEntry } from 'src/app/shared/entrys/notificacion.entry';
import { ModalCorreoMensajeComponent } from '../modal-correo-mensaje/modal-correo-mensaje.component';
import { Subscription } from 'rxjs';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { NotificacionService } from '../../containers/bandeja-principal/prestador/notificacion/notificacion.service';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { AlertType } from 'src/app/shared/models/alert.model';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';

@Component({
	selector: 'app-modal-comentarios',
	templateUrl: './modal-comentarios.component.html',
	styleUrls: ['./modal-comentarios.component.scss']
})
export class ModalComentariosComponent implements OnInit {
	// @Input()
	// comentarios: Array<any>;

	headers: Array<string>;
	modalGenerico: ModalGenericoModel;
	notificiones: Array<NotificacionEntry>;
	suscripcion: Subscription;
	rnt: RNTPrestadorEntry;
	dataTabla: DatoPaginadoModel;
	userLogin: boolean;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	funcionario = RolesUsuario.Funcionario;
	soloConsulta = RolesUsuario.SoloConsulta;
	soloConsultaNacional = RolesUsuario.SoloConsultaNacional;
	paginaActual: number;
	constructor(private activeModal: NgbActiveModal, private notificacionService: NotificacionService, public authService: AuthService,
		private dataSharedService: DataSharedService, private modalService: NgbModal, private alertService: AlertsService) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.suscripcion = dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
			this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
		});
		this.userLogin = authService.isToken();
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.notificacionService.get({ codigo_camara: this.rnt.codigo_camara, rnt_id: this.rnt.rnt_id, numeroPagina:this.paginaActual }).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.notificiones = this.dataTabla.items as Array<NotificacionEntry>;
				// tslint:disable-next-line:max-line-length
				this.headers = ['Fecha de Envío', 'Número Radicado', 'Tipo Solicitud', 'Tipo Notificación','Causales de devolución', 'Asunto Enviado', 'Usuario creación', 'Ver mensaje', 'Reenviar correo'];
			}
		});
		this.modalGenerico = {
			titulo: 'Comentarios del abogado'
		};
	}

	confirm(): void {
		if (this.activeModal) {
			this.activeModal.close();
		}
	}

	dismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.notificacionService.get({ codigo_camara: this.rnt.codigo_camara, rnt_id: this.rnt.rnt_id, numeroPagina:this.paginaActual }).subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
				this.notificiones = this.dataTabla.items as Array<NotificacionEntry>;
			}
		});
	}

	onCorreoMensaje(entry: NotificacionEntry) {
		const modalRef = this.modalService.open(ModalCorreoMensajeComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
		modalRef.componentInstance.notificacion = entry;
	}
	onReenviar(entry: NotificacionEntry) {
		if (entry.numero_intento_envio <= 3) {
			this.notificacionService.sendMail(entry).subscribe(resultado => {
				if (resultado.result) {
					if (resultado.data) {
						entry.numero_intento_envio += 1;
					}
					this.alertService
						.alert(resultado.control.alert_type as AlertType, resultado.control.message,
							`/detalle-solicitud`,
							resultado.control.code.toString());
				}
			});
		} else {
			this.alertService
				.alert(AlertType.Error, 'Ha cumplido el número de intentos permitidos(3)',
					`/detalle-solicitud`, '0');
		}


	}
}
